export enum DomainKind {
    WEB = 0,
    API = 1,
    ALIAS = 2
}
